import { Controller } from "@hotwired/stimulus"

/*
 * FlashModalController — shows flash messages as styled modals.
 *
 * Expected data attributes on the host element:
 *   data-flash-type="notice|alert|error"
 *   data-flash-message="Your message here"
 *
 * The controller auto-shows the modal on connect and removes it after animation.
 */
export default class extends Controller {
  static values = {
    type: String,
    message: String,
    heading: { type: String, default: "ATTENTION" }
  }

  connect() {
    if (!this.hasTypeValue || !this.hasMessageValue) return
    this.show()
  }

  show() {
    const isAlert = this.typeValue === "alert" || this.typeValue === "error"

    // Create overlay
    const overlay = document.createElement("div")
    overlay.className = "fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm"
    overlay.style.opacity = "0"
    overlay.style.transition = "opacity 0.2s ease"

    // Create modal card
    const modal = document.createElement("div")
    modal.className = "bg-white border-2 border-black p-8 md:p-10 max-w-lg w-full shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] flex flex-col gap-6"
    modal.style.transform = "scale(0.95)"
    modal.style.transition = "transform 0.15s ease"

    const content = document.createElement("div")
    if (isAlert) {
      const heading = document.createElement("h3")
      heading.className = "text-2xl font-black tracking-tighter uppercase mb-3 text-black"
      heading.textContent = this.headingValue
      content.appendChild(heading)
    }
    const paragraph = document.createElement("p")
    paragraph.className = "text-gray-600 font-serif text-lg leading-relaxed"
    paragraph.textContent = this.messageValue
    content.appendChild(paragraph)
    modal.appendChild(content)

    overlay.appendChild(modal)
    document.body.appendChild(overlay)

    // Animate in
    requestAnimationFrame(() => {
      overlay.style.opacity = "1"
      modal.style.transform = "scale(1)"
    })

    // Fade out and remove
    setTimeout(() => {
      overlay.style.pointerEvents = "none"
      overlay.style.opacity = "0"
      modal.style.transform = "scale(0.95)"
      setTimeout(() => overlay.remove(), 300)
    }, 1700)
  }
}
